import React from 'react';
import styled from 'styled-components';


import {OzTextarea, OzButton, OzCard} from '@ozwol/webui';

import WebhookWizard from './WebhookWizard';

import CardHeaderTitle from '../components/CardHeaderTitle';

const Container = styled.div`
  width: 450px;
`;

const ModalWebhook4 = ({item, onSuccess}) => {


  return (
    <Container>

      <OzCard
        headerLeft={
          <CardHeaderTitle title={"Enter the Code"} />
        }
        headerSeparator={true}
        footerRight={<OzButton variant={"chetwodeblue-o"} onClick={() => onSuccess()}>Close</OzButton>}
      >
        {/* xxx
        <br/> */}
          
        <OzTextarea
          label="HMAC"
          width="100%"
					disabled
          value={item && item.hmacKey ? item.hmacKey : ""}
        />

        <br/>
        <WebhookWizard step={4} />


      </OzCard>

    </Container>
  );

}

export default ModalWebhook4;
